import { render, staticRenderFns } from "./ComponentConteudoParceiros.vue?vue&type=template&id=7a62a9f1&scoped=true&"
import script from "./ComponentConteudoParceiros.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoParceiros.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoParceiros.vue?vue&type=style&index=0&id=7a62a9f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a62a9f1",
  null
  
)

export default component.exports